

























import Vue from "vue";
import dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  props: ["category"],
  data() {
    return {
      filter1: null,
      csvimport_dialog: false,
      columnDefs: null,
      sideBar: "columns",
      rowData: null,
      defaultColDef: {},
      dialog1: false,
      dropzoneOptions2: {
        url: Vue.prototype.$apiBase + "/inspect-app/import-csv-checklist",
        //headers:{   "x-access-token":localStorage.getItem('token') },
        addRemoveLinks: false,
        params: { cat: "csv" },
        acceptedFiles: ".csv",
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i>  Upload CSV file or drag here</p>
          `,
      },
    };
  },
  components: {
    vueDropzone: dropzone,
  },
  watch: {},
  computed: {},
  beforeMount() {},
  mounted() {
    this.csvimport_dialog = true;
  },
  destroyed() {
    //console.log("destroyed")
  },
  methods: {
    closeDialog: function (info) {
      this.$emit("dialogClosed", info);
    },
    async afterSuccess(file, response) {
      let results = response.data.results;
      this.importSuccess = false;

      this.closeDialog(results.data)

    },
    async afterComplete(upload) {
      //var imageName = uuid.v1();
      this.isLoading = true;
      try {
        //save image
        //let file = upload;
        //console.log(file)
        //var storageRef = firebase.storage().ref();
        //var imageRef = storageRef.child(`images/${imageName}.png`);
        //await imageRef.put(file, metadata);
        //var downloadURL = await imageRef.getDownloadURL();
        //this.images.push({ src: downloadURL });
      } catch (error) {
        console.log(error);
      }
      this.$refs.imgDropZone2.removeFile(upload);
    },
  },
};
